// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7646 ? "a3319169" : chunkId) + "." + {"3168":"79001a4eea753f9a","3846":"3501f15a0ee44a46","7646":"383ad9b580ac041a","9108":"0e8c64b130e7ece3"}[chunkId] + ".js";
};